import { isDeletableFromArchive } from '../../utils/statuses';
import { useContext } from 'react';
import { APIContext } from '@monash/portal-frontend-common';
import BaseBulkDeleteModalContents from '../base-bulk-delete-modal-contents/BaseBulkDeleteModalContents';

const BulkDeleteModalContents = ({
  links,
  onClose,
  deleteLink: deleteLinkInParent,
  updateChecked,
  ...modalSectionProps
}) => {
  const { deleteArchivedLink } = useContext(APIContext);

  return (
    <BaseBulkDeleteModalContents
      relevantLinks={links.filter(isDeletableFromArchive)}
      onClose={onClose}
      deleteRequestFn={deleteArchivedLink}
      deleteLinkInParent={deleteLinkInParent}
      updateChecked={updateChecked}
      {...modalSectionProps}
    />
  );
};

export default BulkDeleteModalContents;
